import * as React from 'react';

export interface LoadingOverlayHandler {
  loadingCount: number;
  isLoading: () => boolean;
  increaseLoading: () => void;
  decreaseLoading: () => void;
  withLoadingOverlay: (promise: Promise<any>) => void;
}

export interface ApplicationContextValue {
  loadingHandler: LoadingOverlayHandler;
}

const ApplicationContext = React.createContext<ApplicationContextValue>({
  loadingHandler: {
    loadingCount: 0,
    isLoading: () => false,
    increaseLoading: () => {
    },
    decreaseLoading: () => {
    },
    withLoadingOverlay: () => {
    },
  },
});

export const ApplicationContextConsumer = ApplicationContext.Consumer;

class ApplicationContextProvider extends React.Component<any, ApplicationContextValue> {

  public state = {
    loadingHandler: {
      loadingCount: 0,
      isLoading: () => {
        return this.state.loadingHandler.loadingCount > 0;
      },
      increaseLoading: () => {
        this.setState((prevState) => ({
          loadingHandler: {
            ...prevState.loadingHandler,
            loadingCount: prevState.loadingHandler.loadingCount + 1
          }
        }));
      },
      decreaseLoading: () => {
        this.setState((prevState) => {
          if (prevState.loadingHandler.loadingCount === 0) {
            console.error("LoadingHandler: loadingCount was already zero! Maybe too many calls of decreaseLoading()?");
            return null;
          } else {
            return {
              loadingHandler: {
                ...prevState.loadingHandler,
                loadingCount: prevState.loadingHandler.loadingCount - 1
              }
            };
          }
        });
      },
      withLoadingOverlay: (promise: Promise<any>) => {
        this.state.loadingHandler.increaseLoading();
        promise.then(() => {
          this.state.loadingHandler.decreaseLoading();
        })
      },
    },
  };

  public render() {
    return (
      <ApplicationContext.Provider value={this.state}>
        {this.props.children}
      </ApplicationContext.Provider>
    );
  }

}

export default ApplicationContextProvider;

export function increaseLoading(handler?: LoadingOverlayHandler) {
  if (handler) {
    handler.increaseLoading();
  }
}

export function decreaseLoading(handler?: LoadingOverlayHandler) {
  if (handler) {
    handler.decreaseLoading();
  }
}

export function withLoadingOverlay(promise: Promise<any>, handler?: LoadingOverlayHandler) {
  if (handler) {
    handler.withLoadingOverlay(promise);
  }
}

interface LoadingOverlayHandlerHolder {
  loadingHandler?: LoadingOverlayHandler;
}

export const bindLoadingHandler = (handler: LoadingOverlayHandler, holder: LoadingOverlayHandlerHolder): React.ReactNode => {
  holder.loadingHandler = handler;
  return null;
};


// WEBPACK FOOTER //
// ./src/app/ApplicationContext.tsx